import { EmptyState } from '../components/ui';

export default function SalesSection() {
  return (
    <EmptyState
      title="Sales pipeline"
      message="Active leads, proposals out, closed-won value vs target. Either wire Pipedrive (or your CRM) in src/sources/pipedrive.ts, or use the manual weekly entry form (POST /manual/sales-pipeline)."
    />
  );
}
